<template lang="html">
  <div>
    <template>
      <div>
        <div class="vx-card nexteventheader_div">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>Edit Profile</h4>
            </div>
          </div>
        </div>
      </div>
      <vx-card>
        <div>
            <form @submit.prevent="handleSubmit">
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            {{$t('FirstName')}}: 
                        </label>
                        <vs-input
                            v-model="firstname"
                            type="text"
                            class="w-full"
                            name="firstname"
                            v-validate="'required'"
                            disabled
                        />
                        <span class="text-danger">{{ errors.first('firstname') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            {{$t('LastName')}}: 
                        </label>
                        <vs-input
                            v-model="lastname"
                            type="text"
                            class="w-full"
                            name="lastname"
                            v-validate="'required'"
                            disabled
                        />
                        <span class="text-danger">{{ errors.first('lastname') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            Email: 
                        </label>
                        <vs-input
                            v-model="email"
                            type="text"
                            class="w-full"
                            name="email"
                            v-validate="'required'"
                            disabled
                        />
                        <span class="text-danger">{{ errors.first('email') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            {{$t('Contact')}}: 
                        </label>
                        <vs-input
                            v-model="contact"
                            type="text"
                            class="w-full"
                            name="contact"
                            v-validate="'required'"
                            disabled
                        />
                        <span class="text-danger">{{ errors.first('contact') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            Old Password: 
                            <!-- <feather-icon icon="EyeIcon" svgClasses="w-4 h-4" /> -->
                        </label>
                        <vs-input
                            v-model="oldpassword"
                            type="password"
                            class="w-full"
                            name="oldpassword"
                            v-validate="'required'"
                        />
                        <span class="text-danger">{{ errors.first('oldpassword') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>New Password:</label>
                        <vs-input
                            type="password"
                            v-model="newpassword"
                            class="w-full"
                            name="newpassword"
                            v-validate="'required'"
                        />
                        <span class="text-danger">{{ errors.first('newpassword') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>Confirm New Password:</label>
                        <vs-input
                            type="password"
                            v-model="confirmpassword"
                            class="w-full"
                            name="confirmpassword"
                            v-validate="'required'"
                        />
                        <span class="text-danger">{{ errors.first('confirmpassword') }}</span>
                    </div>
                </div>
                <vs-button style="margin-top: 30px;" @click="handleSubmit">Update</vs-button>
            </form>
        </div>
      </vx-card>
    </template>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import $ from "jquery";
import Vue from 'vue';

import { Validator } from "vee-validate";

const dict = {
    custom: {
        oldpassword: {
        required: "Old password field is required"
        },
        newpassword: {
        required: "New password field is required"
        },
        confirmpassword: {
        required: "Confirm password field is required"
        }
    },
    messages:{
        required: () => 'This field is required'
    }
};

// register custom messages
Validator.localize("en", dict);

export default {
  data: () => ({
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
    currentUser: '',
    firstname: '',
    lastname: '',
    email: '',
    contact: '',
    user_id: '',
    submitted: false,
  }),
  mounted(){
    this.currentUser = this.$store.getters.currentUser;
    this.firstname = this.currentUser.first_name;
    this.lastname = this.currentUser.last_name;
    this.email = this.currentUser.email;
    this.contact = this.currentUser.mobile_number;
  },
  methods: { 
    handleSubmit(e) {
        this.submitted = true;
        this.$validator.validate().then(valid => {
            if (valid) {
                this.user_id = this.currentUser.id;
                if(this.newpassword == this.confirmpassword){
                    this.$vs.loading();
                    let data = {"id":this.user_id, "current_password":this.oldpassword, "new_password": this.newpassword};
                    this.$store
                    .dispatch("ChangePassword",data)
                    .then(response => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Success",
                            text: "Password updated successfully. Please login again.",
                            color: "success",
                            position: "top-center"
                        });
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        // Error response
                        this.$vs.notify({
                            title: "Failed to update password",
                            text: error,
                            color: "danger",
                            position: "top-center"
                        });
                        return false;
                    });
                } else {
                    this.$vs.loading.close();
                    // Error
                    this.$vs.notify({
                        title: "Failed to update password",
                        text: "Confirm password failed",
                        color: "danger",
                        position: "top-center"
                    });
                    return false;
                }
            }
        });
    },
  },
}
</script>
<style lang="scss">
  .vx-card__actions{
    display: none;
  }
  .vx-card{
    box-shadow: 0px 25px 25px 0px rgba(0, 0, 0, 0.1) !important;
    border-radius: 0 !important;
  }
  .updateConfigBtn{
    padding: 0.70rem 1.5rem !important;
    margin: 4px !important;
  }
</style>